enum COMPARISON_OPERATORS {
  EQ = "EQUAL TO",
  NE = "NOT EQUAL TO",
  CON = "CONTAINS",
  GT = "GREATER THAN",
  GTE = "GREATER THAN EQUAL TO",
  LT = "LESS THAN",
  LTE = "LESS THAN EQUAL TO",
  SET = "IS DEFINED",
  NSET = "IS NOT DEFINED",
}

enum LOGICAL_OPERATORS {
  AND = "AND",
  OR = "OR",
}

interface ConditonData {
  value_1: string;
  value_2: string;
  logical_operator: LOGICAL_OPERATORS;
  comparison_operator: COMPARISON_OPERATORS;
}

function handleCondition(conditionData: ConditonData[]): boolean {
  const result = conditionData.reduce(
    (pre_result: boolean, data: ConditonData): boolean => {
      const { value_1, value_2, comparison_operator, logical_operator } = data;
      const cur_result = handleComparisonOperator(
        String(value_1),
        String(value_2),
        comparison_operator,
      );

      return handleLogicalOperator(pre_result, cur_result, logical_operator);
    },
    true,
  );

  return result;
}

function handleComparisonOperator(
  value_1: string | boolean,
  value_2: string | boolean,
  operator: COMPARISON_OPERATORS,
): boolean {
  switch (operator) {
    case "EQUAL TO":
      return value_1 === value_2;
    case "NOT EQUAL TO":
      return value_1 !== value_2;
    case "CONTAINS":
      return String(value_1).includes(String(value_2));
    case "GREATER THAN":
      isNaN(Number(value_1)) || (value_1 = Number(value_1) as any);
      isNaN(Number(value_2)) || (value_2 = Number(value_2) as any);
      return value_1 > value_2;
    case "GREATER THAN EQUAL TO":
      isNaN(Number(value_1)) || (value_1 = Number(value_1) as any);
      isNaN(Number(value_2)) || (value_2 = Number(value_2) as any);
      return value_1 >= value_2;
    case "LESS THAN":
      isNaN(Number(value_1)) || (value_1 = Number(value_1) as any);
      isNaN(Number(value_2)) || (value_2 = Number(value_2) as any);
      return value_1 < value_2;
    case "LESS THAN EQUAL TO":
      isNaN(Number(value_1)) || (value_1 = Number(value_1) as any);
      isNaN(Number(value_2)) || (value_2 = Number(value_2) as any);
      return value_1 <= value_2;
    case "IS DEFINED":
      return !!value_1;
    case "IS NOT DEFINED":
      return !value_1;
    default:
      return false;
  }
}

function handleLogicalOperator(
  value_1: boolean,
  value_2: boolean,
  operator: LOGICAL_OPERATORS,
): boolean {
  switch (operator) {
    case "AND":
      return value_1 && value_2;
    case "OR":
      return value_1 || value_2;
    default:
      return false;
  }
}

export { handleCondition, handleComparisonOperator, handleLogicalOperator };
